(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flash-sale-bar-landing"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var copyButtons = document.querySelectorAll('.flash-sale-copy-btn');
    copyButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var couponCode = this.getAttribute('data-coupon-code');
        if (couponCode) {
          var buttonText = btn.querySelector('span');
          if (buttonText) {
            var originalText = buttonText.textContent;
            navigator.clipboard.writeText(couponCode).then(function() {
              buttonText.textContent = 'Copiado!';
              setTimeout(function() {
                buttonText.textContent = originalText;
              }, 1500);
            }).catch(function(err) {});
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
